var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9165 3.33341C1.9165 2.5512 2.55096 1.91675 3.33317 1.91675H12.6665C13.4487 1.91675 14.0832 2.5512 14.0832 3.33341V5.05741C14.0832 5.43294 13.9342 5.79305 13.6682 6.05908C13.6387 6.08857 13.6068 6.11554 13.5728 6.13973L10.1015 8.61106C9.76404 8.85129 9.29575 8.77249 9.05552 8.43506C8.81529 8.09762 8.89409 7.62933 9.23153 7.3891L12.5832 5.00298V3.41675H3.4165V5.00298L6.76814 7.3891C7.10558 7.62933 7.18438 8.09762 6.94415 8.43506C6.70392 8.77249 6.23563 8.85129 5.8982 8.61106L2.42686 6.13973C2.39344 6.11593 2.36202 6.08943 2.33292 6.06049C2.06473 5.79372 1.9165 5.43178 1.9165 5.05741V3.33341Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33301 7.25C6.74722 7.25 7.08301 7.58579 7.08301 8V13.166C7.08301 13.2203 7.13412 13.2601 7.18666 13.247L8.85311 12.8304C8.89013 12.8211 8.91634 12.7876 8.91634 12.7493V8C8.91634 7.58579 9.25213 7.25 9.66634 7.25C10.0806 7.25 10.4163 7.58579 10.4163 8V12.7493C10.4163 13.4764 9.92122 14.1095 9.21691 14.2856L7.55024 14.7023C6.55078 14.9518 5.58301 14.1957 5.58301 13.166V8C5.58301 7.58579 5.91879 7.25 6.33301 7.25Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFunnel);
export default __webpack_public_path__ + "static/media/icon-funnel.21921876d55210129661eec0a8dfeb8d.svg";
export { ForwardRef as ReactComponent };